import { getConfig } from "../../../utils/environment.ts";
import {
  BRAND_3D_PAPERWORLD_ICON_PRESET,
  BRAND_COLLAGE_ICON_PRESET,
  BRAND_EXPAND_HERO_PRESET,
  BRAND_EXTEND_ICON_BANK_PRESET,
  BRAND_HERO_SATURATION_PRESET,
  BRAND_MINIMAL_BLUE_LOGO_PRESET,
  BRAND_MONO_MOSAIC_BG_PRESET,
  BRAND_PASTEL_OASIS_PATTERN_PRESET,
  BRAND_UPSCALE_PRESET,
  MOODBOARD_3D_GEOMETRIC_SHAPES_PRESET,
  MOODBOARD_BRAND_COLLECTION_PRESET,
  MOODBOARD_BW_HIGH_CONTRAST_PRESET,
  MOODBOARD_COLORFUL_LIVELY_PRESET,
  MOODBOARD_NEON_NIGHT_PHOTOGRAPHY_PRESET,
  MOODBOARD_PASTEL_PHOTOS_PRESET,
  MOODBOARD_RETRO_VIBES_PRESET,
  MOODBOARD_VINTAGE_SEPIA_PRESET,
  MOODBOARD_WARM_COZY_ILLUSTRATION_PRESET,
  OUTDOOR_ILLUSTRATION_WATERCOLOR_FOREST_PRESET,
  OUTDOOR_MOSAIC_LAKE_SUNSET_PRESET,
  OUTDOOR_PHOTO_ANIME_BEACH_PRESET,
  OUTDOOR_PHOTO_EDIT_SKY_SUNSET_PRESET,
  OUTDOOR_PHOTO_EXPAND_PANORAMA_PRESET,
  OUTDOOR_PHOTO_FRIENDS_SUNSET_PRESET,
  OUTDOOR_PHOTO_MODEL_CITY_PARK_PRESET,
  OUTDOOR_PHOTO_PRODUCT_NATURE_TABLE_PRESET,
  OUTDOOR_PHOTO_SHOES_URBAN_STEPS_PRESET,
  OUTDOOR_PHOTO_SHOOT_ARCHITECTURE_PRESET,
  OUTDOOR_PHOTO_SHOOT_FASHION_EDITORIAL_PRESET,
  OUTDOOR_PHOTO_SHOOT_OBJECT_WITH_MODEL_SHOWCASE_PRESET,
  OUTDOOR_PHOTO_UPSCALE_PRESET,
  PORTRAIT_ASTRID_RETRO_VIBES_PRESET,
  PORTRAIT_BEN_UPSCALE_PRESET,
  PORTRAIT_BLACK_AND_WHITE_PRESET,
  PORTRAIT_DOUBLE_EXPOSURE_PRESET,
  PORTRAIT_FISHERMAN_MOSAIC_PRESET,
  PORTRAIT_HANNAH_FISHEYE_CERAMIC_PRESET,
  PORTRAIT_JOHN_EXPAND_PRESET,
  PORTRAIT_JOHN_WHITE_SHIRT_PRESET,
  PORTRAIT_STUDIO_CLASSIC_PRESET,
  PORTRAIT_URBAN_PRESET,
  PORTRAIT_WATERCOLOR_PRESET,
  PRODUCT_SHOT_3D_OBJECT_STUDIO_PRESET,
  PRODUCT_SHOT_3D_TOTE_BAG_STUDIO_PRESET,
  PRODUCT_SHOT_COLOR_VARIANT_SHOT_PRESET,
  PRODUCT_SHOT_DIEGO_JACKET_SHOT_PRESET,
  PRODUCT_SHOT_EXPAND_PRESET,
  PRODUCT_SHOT_EXTERIOR_SHOT_PRESET,
  PRODUCT_SHOT_GLASSES_NEW_YORK_ELECTRIC_PRESET,
  PRODUCT_SHOT_GLASSES_RETRO_PARADISE_PRESET,
  PRODUCT_SHOT_GLASSES_SHOT_PRESET,
  PRODUCT_SHOT_SIMPLE_STUDIO_SHOT_PRESET,
  PRODUCT_SHOT_SMARTPHONE_PRESET,
  PRODUCT_SHOT_UPSCALE_PRESET,
  SOCIAL_AD_BRIEF_BRAND_CAMPAIGN_PRESET,
  SOCIAL_AD_CHARACTER_PRODUCT_REF_PRESET,
  SOCIAL_AD_EDIT_EXISTING_PRESET,
  SOCIAL_AD_EXPAND_STORY_PRESET,
  SOCIAL_AD_PRODUCT_PROMO_PRESET,
  SOCIAL_AD_STYLE_REF_PRESET,
  SOCIAL_AD_UPSCALE_HD_PRESET,
  STOCK_3D_SHAPES_PRESET,
  STOCK_BRAINSTORMING_PRESET,
  STOCK_BREAKFAST_EDIT_PRESET,
  STOCK_BREAKFAST_PRESET,
  STOCK_CARTOON_BACKGROUND_EDIT_PRESET,
  STOCK_CARTOON_CHARACTER_PRESET,
  STOCK_FOREST_EXPAND_PRESET,
  STOCK_FOREST_PRESET,
  STOCK_URBAN_PRESET,
  STOCK_WOODSHOP_PRESET,
  STUDIO_CHARACTER_PORTRAIT_PRESET,
  STUDIO_CINEMATIC_MONOCHROME_PRESET,
  STUDIO_EDITORIAL_CHARACTER_PRESET,
  STUDIO_EXPAND_PRESET,
  STUDIO_FOOD_EDITORIAL_PRESET,
  STUDIO_NEOPOP_BAG_PRESET,
  STUDIO_OBJECT_STILL_LIFE_PRESET,
  STUDIO_PASTEL_OBJECT_PRESET,
  STUDIO_SHOES_HYPERREAL_PRESET,
  STUDIO_SOFT_FASHION_PRESET,
  STUDIO_UPSCALE_PRESET,
  STUDIO_WATERCOLOR_UNIVERSE_PRESET,
} from "../../boardState/constants.ts";
import {
  BRAND_ASSETS_CATEGORY,
  MOODBOARDS_CATEGORY,
  OUTDOOR_PHOTO_SHOOT_CATEGORY,
  PORTRAITS_CATEGORY,
  PRODUCT_PACK_SHOTS_CATEGORY,
  SOCIAL_AND_ADS_VISUALS_CATEGORY,
  STOCK_IMAGES_CATEGORY,
  STUDIO_PHOTO_SHOOT_CATEGORY,
} from "./constants.ts";
import type { QuickAction, QuickActionCategory } from "./types.ts";

// XXX: Default content UUIDs that defines the initial content on dev / staging that will be used for all edition quick actions. Please replace it locally if you want to use a different content.
const DEFAULT_DEV_INITIAL_CONTENT_UUID = "6a55c57d-217c-4062-be04-34d5f179a8d0";
const DEFAULT_STAGING_INITIAL_CONTENT_UUID =
  "955e807d-8d0a-453b-ab98-788bec22cab4";

const CREATIVE_AND_FUN_CATEGORY_LABEL = "Creative & Fun";
const EDITING_TOOLS_CATEGORY_LABEL = "Editing Tools";

export const QUICK_ACTIONS: Record<
  QuickActionCategory,
  { section: string; quickActions: QuickAction[] }[]
> = {
  [SOCIAL_AND_ADS_VISUALS_CATEGORY]: [
    {
      section: "Instant Eye-Catching Social Posts",
      quickActions: [
        {
          label: "Product Promo Post",
          preset: SOCIAL_AD_PRODUCT_PROMO_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/SOCIAL_AD_PRODUCT_PROMO_PRESET.png",
          },
        },
        {
          label: "On-Brand Style Visual",
          preset: SOCIAL_AD_STYLE_REF_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/SOCIAL_AD_STYLE_REF_PRESET_v2.png",
          },
        },
        {
          label: "Product on Model Showcase",
          preset: SOCIAL_AD_CHARACTER_PRODUCT_REF_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/SOCIAL_AD_CHARACTER_PRODUCT_REF_PRESET.png",
          },
        },
        {
          label: "Brand Campaign",
          subLabel: "Full Series from Brief",
          preset: SOCIAL_AD_BRIEF_BRAND_CAMPAIGN_PRESET,
          childrenProp: {
            imageUrls: [
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/SOCIAL_AD_BRIEF_BRAND_CAMPAIGN_PRESET_1.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/SOCIAL_AD_BRIEF_BRAND_CAMPAIGN_PRESET_2.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/SOCIAL_AD_BRIEF_BRAND_CAMPAIGN_PRESET_3.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/SOCIAL_AD_BRIEF_BRAND_CAMPAIGN_PRESET_4.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/SOCIAL_AD_BRIEF_BRAND_CAMPAIGN_PRESET_5.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/SOCIAL_AD_BRIEF_BRAND_CAMPAIGN_PRESET_6.png",
            ],
            columnsCount: 2,
          },
        },
      ],
    },
    {
      section: EDITING_TOOLS_CATEGORY_LABEL,
      quickActions: [
        {
          label: "Create Variations of Existing Ad",
          subLabel: "Product Color Variations",
          preset: SOCIAL_AD_EDIT_EXISTING_PRESET,
          childrenProp: {
            leftImageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/SOCIAL_AD_EDIT_EXISTING_PRESET_LEFT_v2.png",
            rightImageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/SOCIAL_AD_EDIT_EXISTING_PRESET_RIGHT_v2.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "3f98714c-a0a3-4268-bf90-ef712a59cd49",
          }),
        },
        {
          label: "Expand for Instagram Story/Ad",
          preset: SOCIAL_AD_EXPAND_STORY_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/SOCIAL_AD_EXPAND_STORY_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "b3a030c0-cb33-4e87-be04-a181fe10bc5c",
          }),
        },
        {
          label: "Upscale for HD Social Delivery",
          preset: SOCIAL_AD_UPSCALE_HD_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/SOCIAL_AD_UPSCALE_HD_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "6c30b4ba-0a19-4be9-aa52-0ff411d56cab",
          }),
        },
      ],
    },
  ],
  [PRODUCT_PACK_SHOTS_CATEGORY]: [
    {
      section: "Real-World Products",
      quickActions: [
        {
          label: "Fashion Product on Model",
          preset: PRODUCT_SHOT_DIEGO_JACKET_SHOT_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PRODUCT_SHOT_DIEGO_JACKET_SHOT_PRESET.png",
          },
        },
        {
          label: "Minimalist Catalog Shot",
          preset: PRODUCT_SHOT_GLASSES_SHOT_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PRODUCT_SHOT_GLASSES_SHOT_PRESET.png",
          },
        },
        {
          label: "Product on Display",
          preset: PRODUCT_SHOT_3D_TOTE_BAG_STUDIO_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PRODUCT_SHOT_3D_TOTE_BAG_STUDIO_PRESET.png",
          },
        },
      ],
    },
    {
      section: "Conceptual Studio Shots",
      quickActions: [
        {
          label: "Sleek Product Showcase",
          preset: PRODUCT_SHOT_SMARTPHONE_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PRODUCT_SHOT_SMARTPHONE_PRESET.png",
          },
        },
        {
          label: "Classic Studio Packshot",
          preset: PRODUCT_SHOT_SIMPLE_STUDIO_SHOT_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PRODUCT_SHOT_SIMPLE_STUDIO_SHOT_PRESET.png",
          },
        },
        {
          label: "Lifestyle Outdoor Product Scene",
          preset: PRODUCT_SHOT_EXTERIOR_SHOT_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PRODUCT_SHOT_EXTERIOR_SHOT_PRESET.png",
          },
        },
        {
          label: "Stylized Hero Product Showcase",
          preset: PRODUCT_SHOT_3D_OBJECT_STUDIO_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PRODUCT_SHOT_3D_OBJECT_STUDIO_PRESET.png",
          },
        },
      ],
    },
    {
      section: EDITING_TOOLS_CATEGORY_LABEL,
      quickActions: [
        {
          label: "Create Product Variations",
          subLabel: "Color Variations",
          preset: PRODUCT_SHOT_COLOR_VARIANT_SHOT_PRESET,
          childrenProp: {
            leftImageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PRODUCT_SHOT_COLOR_VARIANT_SHOT_PRESET_LEFT.png",
            rightImageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PRODUCT_SHOT_COLOR_VARIANT_SHOT_PRESET_RIGHT.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "13a6ece4-535d-4364-93cc-2a3237df796b",
          }),
        },
        {
          label: "One-Click Upscale (for Print & HD)",
          preset: PRODUCT_SHOT_UPSCALE_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PRODUCT_SHOT_UPSCALE_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "c90008fc-caa3-4edc-b6f3-7671b2e1548b",
          }),
        },
        {
          label: "Effortless Horizontal Expansion",
          preset: PRODUCT_SHOT_EXPAND_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PRODUCT_SHOT_EXPAND_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "41f9eac7-0e3e-4eb4-bcae-089ecdd35be1",
          }),
        },
      ],
    },
    {
      section: CREATIVE_AND_FUN_CATEGORY_LABEL,
      quickActions: [
        {
          label: "Retro Glasses Pop Illustration",
          preset: PRODUCT_SHOT_GLASSES_RETRO_PARADISE_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PRODUCT_SHOT_GLASSES_RETRO_PARADISE_PRESET.png",
          },
        },
        {
          label: "Neon Urban Glasses",
          preset: PRODUCT_SHOT_GLASSES_NEW_YORK_ELECTRIC_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PRODUCT_SHOT_GLASSES_NEW_YORK_ELECTRIC_PRESET.png",
          },
        },
      ],
    },
  ],
  [OUTDOOR_PHOTO_SHOOT_CATEGORY]: [
    {
      section: "Real-World Scenes",
      quickActions: [
        {
          label: "Model Shooting",
          preset: OUTDOOR_PHOTO_MODEL_CITY_PARK_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/OUTDOOR_PHOTO_MODEL_CITY_PARK_PRESET.png",
          },
        },
        {
          label: "Product on Model Showcase",
          preset: OUTDOOR_PHOTO_SHOOT_OBJECT_WITH_MODEL_SHOWCASE_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/OUTDOOR_PHOTO_SHOOT_OBJECT_WITH_MODEL_SHOWCASE_PRESET.png",
          },
        },
      ],
    },
    {
      section: "Conceptual Shots",
      quickActions: [
        {
          label: "High-End Fashion Editorial",
          preset: OUTDOOR_PHOTO_SHOOT_FASHION_EDITORIAL_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/OUTDOOR_PHOTO_SHOOT_FASHION_EDITORIAL_PRESET.png",
          },
        },
        {
          label: "Modern Architecture Scene",
          preset: OUTDOOR_PHOTO_SHOOT_ARCHITECTURE_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/OUTDOOR_PHOTO_SHOOT_ARCHITECTURE_PRESET.png",
          },
        },
        {
          label: "Lifestyle Scene",
          preset: OUTDOOR_PHOTO_FRIENDS_SUNSET_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/OUTDOOR_PHOTO_FRIENDS_SUNSET_PRESET.png",
          },
        },
        {
          label: "On Brand Style Product Shot",
          preset: OUTDOOR_PHOTO_PRODUCT_NATURE_TABLE_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/OUTDOOR_PHOTO_PRODUCT_NATURE_TABLE_PRESET.png",
          },
        },
        {
          label: "Urban Context Product Shot",
          preset: OUTDOOR_PHOTO_SHOES_URBAN_STEPS_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/OUTDOOR_PHOTO_SHOES_URBAN_STEPS_PRESET.png",
          },
        },
      ],
    },
    {
      section: EDITING_TOOLS_CATEGORY_LABEL,
      quickActions: [
        {
          label: "Create Image Variations",
          subLabel: "Change Lighting",
          preset: OUTDOOR_PHOTO_EDIT_SKY_SUNSET_PRESET,
          childrenProp: {
            leftImageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/OUTDOOR_PHOTO_EDIT_SKY_SUNSET_PRESET_LEFT.png",
            rightImageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/OUTDOOR_PHOTO_EDIT_SKY_SUNSET_PRESET_RIGHT.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "7de793ea-81ad-4873-9c17-f008b8b09531",
          }),
        },
        {
          label: "Expand to Panorama",
          preset: OUTDOOR_PHOTO_EXPAND_PANORAMA_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/OUTDOOR_PHOTO_EXPAND_PANORAMA_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "8c356be8-46c5-4b60-a436-a6180bc93c4a",
          }),
        },
        {
          label: "Upscale for Print",
          preset: OUTDOOR_PHOTO_UPSCALE_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/OUTDOOR_PHOTO_UPSCALE_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "7de793ea-81ad-4873-9c17-f008b8b09531",
          }),
        },
      ],
    },
    {
      section: CREATIVE_AND_FUN_CATEGORY_LABEL,
      quickActions: [
        {
          label: "Anime-Style Beach Portrait",
          preset: OUTDOOR_PHOTO_ANIME_BEACH_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/OUTDOOR_PHOTO_ANIME_BEACH_PRESET.png",
          },
        },
        {
          label: "Surreal Watercolor Forest",
          preset: OUTDOOR_ILLUSTRATION_WATERCOLOR_FOREST_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/OUTDOOR_ILLUSTRATION_WATERCOLOR_FOREST_PRESET.png",
          },
        },
        {
          label: "Mosaic Lake Sunset",
          preset: OUTDOOR_MOSAIC_LAKE_SUNSET_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/OUTDOOR_MOSAIC_LAKE_SUNSET_PRESET.png",
          },
        },
      ],
    },
  ],
  [STUDIO_PHOTO_SHOOT_CATEGORY]: [
    {
      section: "Real-World Scenes",
      quickActions: [
        {
          label: "Natural Model Portrait",
          preset: STUDIO_EDITORIAL_CHARACTER_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STUDIO_EDITORIAL_CHARACTER_PRESET.png",
          },
        },
        {
          label: "Indoor Model Photoshoot",
          preset: STUDIO_CHARACTER_PORTRAIT_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STUDIO_CHARACTER_PORTRAIT_PRESET.png",
          },
        },
        {
          label: "Product Still Life Showcase",
          preset: STUDIO_OBJECT_STILL_LIFE_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STUDIO_OBJECT_STILL_LIFE_PRESET.png",
          },
        },
        {
          label: "Brand-Styled Product Photoshoot",
          preset: STUDIO_NEOPOP_BAG_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STUDIO_NEOPOP_BAG_PRESET.png",
          },
        },
      ],
    },
    {
      section: "Conceptual Shots",
      quickActions: [
        {
          label: "High-End Fashion Editorial",
          preset: STUDIO_SOFT_FASHION_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STUDIO_SOFT_FASHION_PRESET.png",
            contains: true,
          },
        },
        {
          label: "Food Editorial",
          preset: STUDIO_FOOD_EDITORIAL_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STUDIO_FOOD_EDITORIAL_PRESET.png",
          },
        },
        {
          label: "In-Style Object Still Life",
          preset: STUDIO_PASTEL_OBJECT_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STUDIO_PASTEL_OBJECT_PRESET.png",
          },
        },
        {
          label: "Hyperreal Product Studio",
          preset: STUDIO_SHOES_HYPERREAL_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STUDIO_SHOES_HYPERREAL_PRESET.png",
          },
        },
      ],
    },
    {
      section: EDITING_TOOLS_CATEGORY_LABEL,
      quickActions: [
        {
          label: "Effortless Horizontal Expansion",
          preset: STUDIO_EXPAND_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STUDIO_EXPAND_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "9fc8aede-e066-415f-a3f8-12b257f4066e",
          }),
        },
        {
          label: "One-Click Upscale (for Print & HD)",
          preset: STUDIO_UPSCALE_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STUDIO_UPSCALE_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "a95e9faa-4e8b-43f4-b1bf-2c76a5e5c5c5",
          }),
        },
      ],
    },
    {
      section: CREATIVE_AND_FUN_CATEGORY_LABEL,
      quickActions: [
        {
          label: "Surreal Pastel Scene",
          preset: STUDIO_WATERCOLOR_UNIVERSE_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STUDIO_WATERCOLOR_UNIVERSE_PRESET.png",
          },
        },
        {
          label: "Black & White Dramatic Studio",
          preset: STUDIO_CINEMATIC_MONOCHROME_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STUDIO_CINEMATIC_MONOCHROME_PRESET.png",
          },
        },
      ],
    },
  ],
  [MOODBOARDS_CATEGORY]: [
    {
      section: "Inspire & Start from Brief",
      quickActions: [
        {
          label: "Convert a creative brief to a moodboard",
          preset: MOODBOARD_WARM_COZY_ILLUSTRATION_PRESET,
          childrenProp: {
            imageUrls: [
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_WARM_COZY_ILLUSTRATION_PRESET_1.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_WARM_COZY_ILLUSTRATION_PRESET_2.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_WARM_COZY_ILLUSTRATION_PRESET_3.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_WARM_COZY_ILLUSTRATION_PRESET_4.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_WARM_COZY_ILLUSTRATION_PRESET_5.png",
            ],
            columnsCount: 2,
          },
        },
        {
          label: "Convert a brand identity to a moodboard",
          preset: MOODBOARD_BRAND_COLLECTION_PRESET,
          childrenProp: {
            imageUrls: [
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_BRAND_COLLECTION_PRESET_1.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_BRAND_COLLECTION_PRESET_2.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_BRAND_COLLECTION_PRESET_3.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_BRAND_COLLECTION_PRESET_4.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_BRAND_COLLECTION_PRESET_5.png",
            ],
            columnsCount: 2,
          },
        },
      ],
    },
    {
      section: "Aesthetic Vision Boards",
      quickActions: [
        {
          label: "Neon Urban Dream Moodboard",
          preset: MOODBOARD_NEON_NIGHT_PHOTOGRAPHY_PRESET,
          childrenProp: {
            imageUrls: [
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_NEON_NIGHT_PHOTOGRAPHY_PRESET_1.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_NEON_NIGHT_PHOTOGRAPHY_PRESET_2.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_NEON_NIGHT_PHOTOGRAPHY_PRESET_3.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_NEON_NIGHT_PHOTOGRAPHY_PRESET_4.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_NEON_NIGHT_PHOTOGRAPHY_PRESET_5.png",
            ],
            columnsCount: 2,
          },
        },
        {
          label: "Geometric 3D Inspiration",
          preset: MOODBOARD_3D_GEOMETRIC_SHAPES_PRESET,
          childrenProp: {
            imageUrls: [
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_3D_GEOMETRIC_SHAPES_PRESET_1.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_3D_GEOMETRIC_SHAPES_PRESET_2.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_3D_GEOMETRIC_SHAPES_PRESET_3.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_3D_GEOMETRIC_SHAPES_PRESET_4.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_3D_GEOMETRIC_SHAPES_PRESET_5.png",
            ],
            columnsCount: 2,
          },
        },
        {
          label: "Pastel Oasis Moodboard",
          preset: MOODBOARD_PASTEL_PHOTOS_PRESET,
          childrenProp: {
            imageUrls: [
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_PASTEL_PHOTOS_PRESET_1.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_PASTEL_PHOTOS_PRESET_2.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_PASTEL_PHOTOS_PRESET_3.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_PASTEL_PHOTOS_PRESET_4.png",
            ],
            columnsCount: 2,
          },
        },
        {
          label: "Retro Vibes Moodboard",
          preset: MOODBOARD_RETRO_VIBES_PRESET,
          childrenProp: {
            imageUrls: [
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_RETRO_VIBES_PRESET_2.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_RETRO_VIBES_PRESET_4.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_RETRO_VIBES_PRESET_1.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_RETRO_VIBES_PRESET_3.png",
            ],
            columnsCount: 2,
          },
        },
      ],
    },
    {
      section: "Photo & Color Exploration",
      quickActions: [
        {
          label: "Black & White High-Contrast",
          preset: MOODBOARD_BW_HIGH_CONTRAST_PRESET,
          childrenProp: {
            imageUrls: [
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_BW_HIGH_CONTRAST_PRESET_1.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_BW_HIGH_CONTRAST_PRESET_2.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_BW_HIGH_CONTRAST_PRESET_3.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_BW_HIGH_CONTRAST_PRESET_4.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_BW_HIGH_CONTRAST_PRESET_5.png",
            ],
            columnsCount: 2,
          },
        },
        {
          label: "Colorful & Lively Moodboard",
          preset: MOODBOARD_COLORFUL_LIVELY_PRESET,
          childrenProp: {
            imageUrls: [
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_COLORFUL_LIVELY_PRESET_1.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_COLORFUL_LIVELY_PRESET_2.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_COLORFUL_LIVELY_PRESET_3.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_COLORFUL_LIVELY_PRESET_4.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_COLORFUL_LIVELY_PRESET_5.png",
            ],
            columnsCount: 2,
          },
        },
        {
          label: "Golden Memory Vintage",
          preset: MOODBOARD_VINTAGE_SEPIA_PRESET,
          childrenProp: {
            imageUrls: [
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_VINTAGE_SEPIA_PRESET_1.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_VINTAGE_SEPIA_PRESET_2.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_VINTAGE_SEPIA_PRESET_3.png",
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/MOODBOARD_VINTAGE_SEPIA_PRESET_4.png",
            ],
            columnsCount: 2,
          },
        },
      ],
    },
  ],
  [BRAND_ASSETS_CATEGORY]: [
    {
      section: "Logo & Icon Essentials",
      quickActions: [
        {
          label: "Minimalist Blue Brand Logo",
          preset: BRAND_MINIMAL_BLUE_LOGO_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/BRAND_MINIMAL_BLUE_LOGO_PRESET.png",
          },
        },
        {
          label: "Modern 3D Icon Set",
          preset: BRAND_3D_PAPERWORLD_ICON_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/BRAND_3D_PAPERWORLD_ICON_PRESET.png",
          },
        },
        {
          label: "Creative Collage Icon",
          preset: BRAND_COLLAGE_ICON_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/BRAND_COLLAGE_ICON_PRESET.png",
          },
        },
        {
          label: "Extend your icon bank",
          preset: BRAND_EXTEND_ICON_BANK_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/BRAND_EXTEND_ICON_BANK_PRESET.png",
          },
        },
      ],
    },
    {
      section: "Hero Visuals & Brand Patterns",
      quickActions: [
        {
          label: "Vibrant Hero Banner",
          preset: BRAND_HERO_SATURATION_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/BRAND_HERO_SATURATION_PRESET.png",
          },
        },
        {
          label: "Abstract Pastel Pattern",
          preset: BRAND_PASTEL_OASIS_PATTERN_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/BRAND_PASTEL_OASIS_PATTERN_PRESET.png",
          },
        },
        {
          label: "Monochrome Mosaic Background",
          preset: BRAND_MONO_MOSAIC_BG_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/BRAND_MONO_MOSAIC_BG_PRESET.png",
          },
        },
      ],
    },
    {
      section: EDITING_TOOLS_CATEGORY_LABEL,
      quickActions: [
        {
          label: "One-Click Horizontal Expansion",
          preset: BRAND_EXPAND_HERO_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/BRAND_EXPAND_HERO_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "5ceac433-e6b5-4d72-ae58-778421f35503",
          }),
        },
        {
          label: "Brand Visual Upscale",
          preset: BRAND_UPSCALE_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/BRAND_UPSCALE_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "873ed332-ca9f-4229-aa7d-5825a4979a1c",
          }),
        },
      ],
    },
  ],
  [PORTRAITS_CATEGORY]: [
    {
      section: "Character-Based Portraits",
      quickActions: [
        {
          label: "Professional Portrait",
          preset: PORTRAIT_JOHN_WHITE_SHIRT_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PORTRAIT_JOHN_WHITE_SHIRT_PRESET.png",
          },
        },
        {
          label: "70s-Inspired Portrait",
          preset: PORTRAIT_ASTRID_RETRO_VIBES_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PORTRAIT_ASTRID_RETRO_VIBES_PRESET.png",
          },
        },
        {
          label: "Stylized Portrait",
          preset: PORTRAIT_HANNAH_FISHEYE_CERAMIC_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PORTRAIT_HANNAH_FISHEYE_CERAMIC_PRESET.png",
          },
        },
      ],
    },
    {
      section: "Conceptual Portraits",
      quickActions: [
        {
          label: "Studio Classic",
          preset: PORTRAIT_STUDIO_CLASSIC_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PORTRAIT_STUDIO_CLASSIC_PRESET.png",
          },
        },
        {
          label: "Outdoor Portrait",
          preset: PORTRAIT_URBAN_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PORTRAIT_URBAN_PRESET.png",
          },
        },
        {
          label: "Black & White Portrait",
          preset: PORTRAIT_BLACK_AND_WHITE_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PORTRAIT_BLACK_AND_WHITE_PRESET.png",
          },
        },
      ],
    },
    {
      section: EDITING_TOOLS_CATEGORY_LABEL,
      quickActions: [
        {
          label: "Profile Photo Upscale",
          preset: PORTRAIT_BEN_UPSCALE_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PORTRAIT_BEN_UPSCALE_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "79851703-0429-4118-9007-9e9076fa6d63",
          }),
        },
        {
          label: "Effortless Photo Expansion",
          preset: PORTRAIT_JOHN_EXPAND_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PORTRAIT_JOHN_EXPAND_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "45895181-07d5-40c5-9569-40fd6f3c7161",
          }),
        },
      ],
    },
    {
      section: CREATIVE_AND_FUN_CATEGORY_LABEL,
      quickActions: [
        {
          label: "Watercolor Illustration",
          preset: PORTRAIT_WATERCOLOR_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PORTRAIT_WATERCOLOR_PRESET.png",
          },
        },
        {
          label: "Mosaic Abstract",
          preset: PORTRAIT_FISHERMAN_MOSAIC_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PORTRAIT_FISHERMAN_MOSAIC_PRESET.png",
          },
        },
        {
          label: "Double Exposure Dream",
          preset: PORTRAIT_DOUBLE_EXPOSURE_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/PORTRAIT_DOUBLE_EXPOSURE_PRESET.png",
          },
        },
      ],
    },
  ],
  [STOCK_IMAGES_CATEGORY]: [
    {
      section: "People & Business",
      quickActions: [
        {
          label: "Team Brainstorming",
          preset: STOCK_BRAINSTORMING_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STOCK_BRAINSTORMING_PRESET.png",
          },
        },
        {
          label: "At the Woodshop",
          preset: STOCK_WOODSHOP_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STOCK_WOODSHOP_PRESET.png",
          },
        },
      ],
    },
    {
      section: "Lifestyle & Nature",
      quickActions: [
        {
          label: "Urban Snapshot",
          preset: STOCK_URBAN_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STOCK_URBAN_PRESET.png",
          },
        },
        {
          label: "Peaceful Forest Landscape",
          preset: STOCK_FOREST_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STOCK_FOREST_PRESET.png",
          },
        },
        {
          label: "Healthy Breakfast Flatlay",
          preset: STOCK_BREAKFAST_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STOCK_BREAKFAST_PRESET.png",
          },
        },
      ],
    },
    {
      section: EDITING_TOOLS_CATEGORY_LABEL,
      quickActions: [
        {
          label: "Change the Menu",
          preset: STOCK_BREAKFAST_EDIT_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STOCK_BREAKFAST_EDIT_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "cfdcaf42-9c48-432e-8459-8388434223bd",
          }),
        },
        {
          label: "Change the Background",
          preset: STOCK_CARTOON_BACKGROUND_EDIT_PRESET,
          childrenProp: {
            leftImageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STOCK_CARTOON_CHARACTER_PRESET.png",
            rightImageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STOCK_CARTOON_BACKGROUND_EDIT_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "d843c7c3-9fd1-49bf-a95b-8c7410fcf094",
          }),
        },
        {
          label: "Vertical Expand",
          preset: STOCK_FOREST_EXPAND_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STOCK_FOREST_EXPAND_PRESET.png",
          },
          createAssetFromContentUuid: getConfig({
            dev: DEFAULT_DEV_INITIAL_CONTENT_UUID,
            staging: DEFAULT_STAGING_INITIAL_CONTENT_UUID,
            prod: "20a045db-3499-42f9-8df6-b2ba660e8372",
          }),
        },
      ],
    },
    {
      section: CREATIVE_AND_FUN_CATEGORY_LABEL,
      quickActions: [
        {
          label: "Abstract Shapes Composition",
          preset: STOCK_3D_SHAPES_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STOCK_3D_SHAPES_PRESET.png",
          },
        },
        {
          label: "Cartoon Character",
          preset: STOCK_CARTOON_CHARACTER_PRESET,
          childrenProp: {
            imageUrl:
              "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/quick_actions/STOCK_CARTOON_CHARACTER_PRESET.png",
          },
        },
      ],
    },
  ],
};
